<div class="main-content">
    <div class="row">
        <div class="col-12 ">
            <mat-card style="box-shadow: none !important;">
                <mat-card-content style="padding: 15px;">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                                <div class="row ">
                                    <div class="col-md-6 col-sm-12 col-12 col-lg-6">
                                        <div class="">
                                            <h5 class="text-weight-bold" style="color: #5B25B4">Upcoming CEU Training</h5>
                                            <div class="d-block" style="color: #979797">Discover upcoming CEU training to earn credits</div>
                                        </div>

                                    </div>
                                    <div class="col-md-6 col-sm-12 col-12 col-lg-6 text-end ">
                                        <div class="d-flex justify-content-between">
                                            <div></div>
                                            <ul class="breadcrumb mt-3 d-none d-sm-none d-md-none d-lg-flex">
                                                <li class="active"><a style="color: #000;" [routerLink]="['/dashboard/home']">Home</a></li>
                                                <li class="separator">/</li>
                                                <li><a href="#">CE Training Portal</a></li>
                                            </ul>
                                        </div>
                                        <mat-form-field class="mt-3 mb-4 w-100" appearance="outline">

                                            <mat-icon matPrefix>search</mat-icon>
                                            <div class="filters" matSuffix *ngIf="filterTotal > 0; else elseFilterTotalZero">
                                                <mat-icon class="filters" matSuffix (click)="openAdvanceSearch()">tune</mat-icon>
                                                <span class="filter-number" matSuffix>{{filterTotal}}</span>
                                                <mat-icon class="filters" matSuffix (click)="clearFilters()">close</mat-icon>
                                            </div>
                                            <ng-template #elseFilterTotalZero>
                                                <mat-icon matSuffix (click)="openAdvanceSearch()">tune</mat-icon>
                                            </ng-template>

                                            <input placeholder="Search" type="text" matInput [(ngModel)]="pageQuery.search" (keyup)="searchCEU($event)">

                                        </mat-form-field>
                                    </div>
                                </div>
                                <div>
                                    <div class="table-responsive list-wrapper-bordered">
                                        <table class="table table-striped table-hover table-borderless border-0 ">
                                            <thead>
                                            <tr>
                                                <th class="text-nowrap">CE Provider</th>
                                                <th class="text-nowrap">CE Type</th>
                                                <th class="text-nowrap">CE Title</th>
                                                <th class="text-nowrap text-center">Attendance Type</th>
                                                <th class="text-nowrap">Event Date</th>
                                                <th class="text-nowrap text-center">Price</th>
                                                <th class="text-nowrap">Location</th>
                                                <th class="text-nowrap sticky-action"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <ng-container *ngIf="upcomingCeuTraining.length > 0; else elseUpcomingCeu">
                                                <tr *ngFor="let d of upcomingCeuTraining;  let i = index">
                                                    <td class="text-nowrap" style="color: #000;"> {{d.provider}}</td>
                                                    <td class="text-nowrap" style="color: #000;"> {{maskingColumn('parameterLabel', 'parameterValue', ceTypeParams.parameterMembers, d.ceType)}}</td>
                                                    <td class="text-nowrap" style="color: #000;"> {{d.title}}</td>
                                                    <td class="text-nowrap text-center" style="color: #000;"> {{maskingColumn('parameterLabel', 'parameterValue', attendanceTypeParams.parameterMembers, d.attendanceType)}}</td>
                                                    <td class="text-nowrap" style="color: #000;"> {{d.startDate | date : "MM/dd/y"}}</td>
                                                    <td class="text-nowrap text-center" style="color: #000;"> $ {{d.cost | number:'1.0-0'}}</td>
                                                    <td class="text-nowrap" style="color: #000;"> {{d.city + ', ' + d.stateOrProvince}}</td>
                                                    <td class="text-nowrap sticky-action">
                                                        <button [disabled]="disabledButtons[i]" (click)="enroll(d, i)" class="btn btn-purple" style="background: #5B25B4; color: #fff;">Enroll</button>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                            <ng-template #elseUpcomingCeu>
                                                <tr>
                                                    <td [colSpan]="8" class="text-center" style="color: #000;">No upcoming event</td>
                                                </tr>
                                            </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="mt-4" *ngIf="upcomingCeuTraining.length > 0">
                                    <app-pagination
                                            (goPage)="toPage($event)"
                                            (goPerPage)="perPageSet($event)"
                                            [pagesToShow]="showPages"
                                            [page]="pageNo"
                                            [perPage]="pageSize"
                                            [count]="totalRow"></app-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
